
import { Notify } from 'quasar'

const state = {
  title: '',
  loading: 0
}

const getters = {
  title: state => state.title,
  loading: state => state.loading
}

const actions = {
  flash: (payload) => {
    Notify.create({
      message: '',
      position: 'top',
      color: 'positive',
      icon: 'check_circle'
    }, ...payload)
  },
  title: ({ commit }, { title }) => {
    commit('title', title)
  },
  loadingAdd: ({ commit }) => {
    commit('loadingAdd')
  },
  loadingRemove: ({ commit }) => {
    commit('loadingRemove')
  },
  loadingReset: ({ commit }) => {
    commit('loadingReset')
  }
}

const mutations = {
  title: (state, title) => {
    state.title = title
  },
  loadingAdd (state) {
    // state.loading++
    state.loading = 1
  },
  loadingRemove (state) {
    /* if (state.loading > 0) {
      state.loading--
    } */
    state.loading = 0
  },
  loadingReset (state) {
    state.loading = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
